import type { Datasets } from "lib/types/graphql";

export function isDeprecated(
  dataset: Pick<Datasets, "name">,
  options: { isSpellbookContributor: boolean }
) {
  if (dataset.name.includes("Spark SQL")) {
    return !options.isSpellbookContributor;
  }

  return dataset.name.includes("[deprecated]");
}

export function isEditingDisabled(
  dataset: Pick<Datasets, "name">,
  options: { isSpellbookContributor: boolean }
) {
  if (dataset.name.includes("Spark SQL")) {
    return !options.isSpellbookContributor;
  }

  return dataset.name.includes("[deprecated]");
}

export function isExecutionDisabled(
  dataset: Pick<Datasets, "name">,
  options: { hasPaidPlan: boolean; isSpellbookContributor: boolean }
) {
  if (dataset.name.includes("Spark SQL")) {
    return !(options.hasPaidPlan || options.isSpellbookContributor);
  }

  return !dataset.name.includes("Dune SQL");
}
